export enum MKStartOffsetTimelineReference {
    /**
     * `startOffset` will be calculated from the beginning of the stream or DVR window.
     *
     * This is the default option for VOD. Specifiying this reference point for VOD is not necessary.
     * 
     * **NOTE** This is applicable only for Live when `startOffset` is `0` and when set will start live playback from the beginning insted of the live edge.
     */
    Start = "start",

    /**
     * `startOffset` will be calculated from the end of the stream or the live edge in case of a live stream with DVR window.
     *
     * This is the default option for Live. Specifying this reference point for VOD is not recommended as it will attempt to start playback at the end of the asset which is not useful.
     * 
     * **NOTE** This is applicable only for Live when `startOffset` is `0` and when set will start playback at the live edge.
     */
    End = "end"
}